// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderTopic_header__GFGAz"};